import { canv } from "@/canv/global.js";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapeDisplay extends Shape {
    width = 200;
    height = 164;

    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = width - width / 4 - width / 8 - 2 * horizontalPadding;
        const allowedHeight = height - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        this.updateTextDims(textPart);

        textPart.startX = x + width / 4 + (width - width / 4 - width / 8) / 2 - textPart.width / 2;
        textPart.startY = y + this.getTextLineHeight(textPart) + height / 2 - textPart.height / 2;

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number) {
        let r = height / 30;

        if (width < 2 * r) r = width / 2;

        canv.ctx.beginPath();
        canv.ctx.moveTo(x + (width * 7) / 8, y);
        canv.ctx.lineTo(x + width / 4, y);
        canv.ctx.lineTo(x, y + height / 2);
        canv.ctx.lineTo(x + width / 4, y + height);
        canv.ctx.lineTo(x + (width * 7) / 8, y + height);
        canv.ctx.ellipse(
            x + (width * 7) / 8,
            y + height / 2,
            width / 8,
            height / 2,
            0,
            (1 / 2) * Math.PI,
            (3 / 2) * Math.PI,
            true,
        );
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="${fill}" stroke="${stroke}" stroke-linejoin="round" d="M5.84 3h15.31S23 7.2 23 12s-1.85 9-1.85 9H5.84L1 12l4.84-9Z"/>
            </svg>
        `;
    }
}
